import { createSelectedChannel, findChannel, findChannelById } from '@jetshop/core/ChannelHandler/channelUtils';
import { styled } from 'linaria/react';
import React from 'react';
/** Wraps either MiniSelector or LargeSelector and provides controlled state */

export default class ChannelSelector extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      selectedChannel: this.props.initialChannel,
      hasChanged: false
    };

    this.setDirtyState = () => {
      const hasChanged = this.state.selectedChannel.name !== this.props.initialChannel.name || this.state.selectedChannel.language.name !== this.props.initialChannel.language.name || this.state.selectedChannel.currency.name !== this.props.initialChannel.currency.name || this.state.selectedChannel.country.name !== this.props.initialChannel.country.name;
      this.setState({
        hasChanged
      });
    };

    this.selectChannel = (channel, culture, currency, country) => {
      const selectedChannel = createSelectedChannel(typeof channel === 'number' ? findChannelById(channel, this.props.channels) : findChannel(channel, this.props.channels), culture, currency, country);
      this.setState({
        selectedChannel
      });
      return selectedChannel;
    };

    this.selectCurrency = selectedCurrency => {
      const currency = this.state.selectedChannel.currencies.find(currency => currency.name === selectedCurrency);
      this.setState({
        selectedChannel: Object.assign(Object.assign({}, this.state.selectedChannel), {
          currency
        })
      });
    };

    this.selectLanguage = selectedLanguage => {
      const language = this.state.selectedChannel.languages.find(language => language.name === selectedLanguage);
      this.setState({
        selectedChannel: Object.assign(Object.assign({}, this.state.selectedChannel), {
          language
        })
      });
    };
  }

  componentDidUpdate(_prevProps, prevState) {
    (prevState.selectedChannel.name !== this.state.selectedChannel.name || prevState.selectedChannel.language.name !== this.state.selectedChannel.language.name || prevState.selectedChannel.currency.name !== this.state.selectedChannel.currency.name || prevState.selectedChannel.country.name !== this.state.selectedChannel.country.name) && this.setDirtyState();
  }

  render() {
    const {
      render,
      channels
    } = this.props;
    const currencyItems = this.state.selectedChannel.currencies.map(currency => {
      return {
        label: currency.name,
        val: currency.name
      };
    });
    const languageItems = this.state.selectedChannel.languages.map(language => {
      return {
        label: language.name,
        val: language.name
      };
    });
    return render(Object.assign(Object.assign({}, this.state), {
      channels,
      currencyItems,
      languageItems,
      onSelect: this.selectChannel,
      onCurrencySelect: this.selectCurrency,
      onLanguageSelect: this.selectLanguage
    }));
  }

} // For some reason Styleguidist breaks unless this comes after
// the default export

export const LangCurrWrapper = /*#__PURE__*/styled('div')({
  name: "LangCurrWrapper",
  class: "lvwr69r"
});
export const SelectorBody = /*#__PURE__*/styled('section')({
  name: "SelectorBody",
  class: "s1o36yse"
});
export const Title = /*#__PURE__*/styled('h1')({
  name: "Title",
  class: "t1eswvp1"
});

require("../../../../.linaria-cache/node_modules/@jetshop/ui/ChannelSelector/ChannelSelector.linaria.css");